import React, { useEffect, useState } from 'react';
import './style.scss';
import '../style.scss';
import { IconColor, IconSize, SvgIcon } from 'views/components/atoms/svgIcon';
import { findIcon, IconName } from 'views/utils/handleIcon';
import { Button, ButtonSize, ButtonType, FillType } from 'views/components/atoms/button';
import { PageLocationSP } from 'views/components/atoms/pageLocation';
import { InquiryMutationVariables, useInquiryMutation } from 'views/utils/graphql/graphql';
import { Tabs } from 'views/components/atoms/tabs';
import { Toast, ToastMessageLevel } from 'views/components/atoms/toast';
import { useToast } from 'views/components/atoms/toast/hook';
import { ModalBase, ModalStyle } from 'views/components/atoms/modal';
import useOnceSubmit from 'views/utils/useOnceSubmit';
export const Contact = () => {
  const [inquiryData, inquiry] = useInquiryMutation();
  const [inputedText, setInputedText] = React.useState<string>('');
  const [selectedTabIndex, setSelectedTabIndex] = React.useState<number>(0);

  const { toastProps, showToast } = useToast();
  const [isShowSuccessMessage, setIsShowSuccessMessage] = useState<boolean>(false);

  const icon = findIcon(IconName.Call);

  const handleSubmitContact = useOnceSubmit<void>(
    {
      onSubmit: async () => {
        const param: InquiryMutationVariables = {
          input: {
            Content: inputedText,
          },
        };
        const inquiryData = await inquiry(param);

        if (!inquiryData.data) return;

        if (inquiryData.data.Inquiry?.Code !== 0) {
          showToast(inquiryData.data.Inquiry?.Message ?? '送信に失敗しました', ToastMessageLevel.Error);
        } else {
          setIsShowSuccessMessage(true);
        }
        setInputedText('');
      },
    },
    [inputedText, showToast, setIsShowSuccessMessage, setInputedText],
  );

  const renderMailContact = () => {
    return (
      <div className="contactWrapper">
        <textarea
          placeholder="お問い合わせ内容"
          value={inputedText}
          onChange={(e) => {
            setInputedText(e.target.value);
          }}
        />
        <Button
          label="送信"
          type={ButtonType.Button}
          fillType={inputedText === '' ? FillType.primaryEmpty : FillType.primaryFill}
          buttonSize={ButtonSize.sizeM}
          onClick={() => {
            if (inputedText === '') return;
            handleSubmitContact();
          }}
        />
        <div className="guidance">
          よくある質問については、
          <a href={process.env.REACT_APP_FAQ_URL} target="_blank" rel="noreferrer noopener">
            こちら
          </a>
          をご覧ください。
        </div>
      </div>
    );
  };

  const renderTellContact = () => {
    return (
      <div className="contactWrapper">
        <span>株式会社FPG証券</span>
        <span>【営業時間】9:30 ~ 17:00（土・日・祝日除く）</span>
        <div className="contactWrapper_number">
          <SvgIcon icon={icon} size={IconSize.icon_l} color={IconColor.primary} />
          <span>03-5220-4217</span>
        </div>
        <div className="guidance">
          よくある質問については、
          <a href={process.env.REACT_APP_FAQ_URL} target="_blank" rel="noreferrer noopener">
            こちら
          </a>
          をご覧ください。
        </div>
      </div>
    );
  };

  return (
    <>
      <section className="outletWrapper">
        <PageLocationSP />
        <div className="centerContent">
          <Tabs
            tabLists={[{ title: 'メールでのお問い合わせ' }, { title: '電話でのお問い合わせ' }]}
            tabContents={[renderMailContact(), renderTellContact()]}
            selectedIndex={selectedTabIndex}
            onSelect={(index) => setSelectedTabIndex(index)}
          />
        </div>
        <ModalBase
          isOpen={isShowSuccessMessage}
          modalStyle={ModalStyle.completeModal}
          children={
            <div className="modalWrapper">
              <span className="finishLabel">お問い合わせを受け付けました</span>
              <Button
                label="閉じる"
                onClick={() => {
                  setIsShowSuccessMessage(false);
                }}
                fillType={FillType.primaryFill}
                buttonSize={ButtonSize.sizeM}
              />
            </div>
          }
        />
        <Toast {...toastProps} />
      </section>
    </>
  );
};
